export default "__VITE_ASSET__DiGQTiTS__"